import { render, staticRenderFns } from "./creatCdkey.vue?vue&type=template&id=48ef8fe0&scoped=true"
import script from "./creatCdkey.vue?vue&type=script&setup=true&lang=js"
export * from "./creatCdkey.vue?vue&type=script&setup=true&lang=js"
import style0 from "./creatCdkey.vue?vue&type=style&index=0&id=48ef8fe0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ef8fe0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ef8fe0')) {
      api.createRecord('48ef8fe0', component.options)
    } else {
      api.reload('48ef8fe0', component.options)
    }
    module.hot.accept("./creatCdkey.vue?vue&type=template&id=48ef8fe0&scoped=true", function () {
      api.rerender('48ef8fe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/cdkey/creatCdkey.vue"
export default component.exports